import LogsArea from "./LogsArea.js";

import Menu from "../Menu.js";
import ModeSwitcher from "../ModeSwitcher.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.LogsArea");
log.setLevel(log.levels.WARN);

const BottomArea = function () {
    var tactical_situation_name;
    var desktop_name = null;
    var switcher_left = null;
    var switcher_left_data = {
        name: "switcher_left",
        container_id: "#command_area_left .btn-switcher-left",
        default_state_name: "tactics",
        modes: ["logs"],
        states: {
            tactics: {
                in: () => {
                    log.debug("SITAC mode switcher > in tactics with context:", global.storage.selected_context);
                    if (global.storage.selected_context != null) {
                        $("#command_map_right").show();
                        this.index = global.storage.selected_context.index;
                        desktop_name.text(tactical_situation_name);
                    } else {
                        desktop_name.text(global.internationalization.text("global.Without-name"));
                    }
                    global.event_bus.publish("mode_switcher.switcher_left", {mode: "tactics"});
                },
                out: () => {
                    log.debug("SITAC mode switcher > out tactics");
                    $("#command_map_right").hide();
                    $("#command_area_left button.desktop-selector.btn-selected").removeClass("btn-selected");
                    if (Menu.currently_opened !== null) {
                        Menu.close(Menu.currently_opened);
                    }
                },
                transit: {
                    tactics: {
                        state: "tactics",
                        handler: () => false
                    },
                    logs: {
                        state: "logs",
                        handler: () => true
                    }
                },
                schedule: {}
            },
            logs: {
                in: (_, sm) => {
                    log.debug("SITAC mode switcher > in logs");
                    sm.data.selector.logs.addClass("btn-selected");
                    $("#command_logs_right").css("display", null);
                    $("#logs_area").css("display", null);
                    $("#flash_message_area").hide();
                    desktop_name.text(global.internationalization.text("logtab.Log-tab"));
                    // to be sure that the log tab is loaded if initial context not changed
                    LogsArea.message_load(global.storage.selected_context.space);
                    global.event_bus.publish("mode_switcher.switcher_left", {mode: "logs"});
                },
                out: (_, sm) => {
                    log.debug("SITAC mode switcher > out logs");
                    sm.data.selector.logs.removeClass("btn-selected");
                    $("#command_logs_right").hide();
                    $("#logs_area").hide();
                    if (Menu.currently_opened !== null) {
                        Menu.close(Menu.currently_opened);
                    }
                },
                transit: {
                    tactics: {
                        state: "tactics",
                        handler: () => true
                    },
                    logs: {
                        state: "logs",
                        handler: () => false
                    }
                },
                schedule: {}
            }
        }
    };

    Object.defineProperty(this, "tactical_situation_name", {
        set: (name) => {
            tactical_situation_name = name;
            if (switcher_left.mode !== "tactics") {
                return;
            }
            desktop_name.text(name || global.internationalization.text("global.Without-name")); // if falsy ("" or null) > Without-name
        },
        get: () => tactical_situation_name
    });

    Object.defineProperty(this, "switcher_left", {
        set: () => {},
        get: () => switcher_left
    });

    global.event_bus.subscribe("internationalization.language.changed", () => {
        this.tactical_situation_name = tactical_situation_name;
    });

    global.app.bootstrap.register_module({
        name: "ui_bottom_area",
        deps: ["dom_loaded", "storage", "internationalization"],
        init: async () => {
            desktop_name = $("<span>").addClass("desktop-label");
            let $desktop_name_btn = $("#view_name");
            $desktop_name_btn.append(desktop_name);
            switcher_left = new ModeSwitcher(switcher_left_data);
            switcher_left.mode = "tactics";
            this.tactical_situation_name = null;
        }
    });
};

export default new BottomArea();
